import { tw } from "@careinfo/tailwind";
import { BubbleMenu as BaseBubbleMenu } from "@tiptap/react";
import React, { memo, useCallback } from "react";
import { MenuProps, ShouldShowProps } from "../../../../components/menus/types";
import { Icon } from "../../../../components/ui/Icon";
import * as PopoverMenu from "../../../../components/ui/PopoverMenu";
import { Toolbar } from "../../../../components/ui/Toolbar";
import { isColumnGripSelected } from "./utils";

const MemoButton = memo(Toolbar.Button);

export const TableColumnMenu = React.memo(
  ({ editor, appendTo }: MenuProps): JSX.Element => {
    const shouldShow = useCallback(
      ({ view, state, from }: ShouldShowProps) => {
        if (!state) {
          return false;
        }

        return isColumnGripSelected({ editor, view, state, from: from || 0 });
      },
      [editor]
    );

    const onAddColumnBefore = useCallback(() => {
      editor.chain().focus().addColumnBefore().run();
    }, [editor]);

    const onAddColumnAfter = useCallback(() => {
      editor.chain().focus().addColumnAfter().run();
    }, [editor]);

    const onDeleteColumn = useCallback(() => {
      editor.chain().focus().deleteColumn().run();
    }, [editor]);

    return (
      <BaseBubbleMenu
        editor={editor}
        pluginKey="tableColumnMenu"
        updateDelay={0}
        tippyOptions={{
          appendTo: () => {
            return appendTo?.current;
          },
          offset: [0, 15],
          popperOptions: {
            modifiers: [{ name: "flip", enabled: false }],
          },
        }}
        shouldShow={shouldShow}
      >
        <Toolbar.Wrapper isVertical>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onAddColumnBefore}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="ArrowLeftToLine" />
              <span>Add column before</span>
            </span>
          </MemoButton>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onAddColumnAfter}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="ArrowRightToLine" />
              <span>Add column after</span>
            </span>
          </MemoButton>
          <MemoButton
            tooltipShortcut={["Mod", "B"]}
            onClick={onDeleteColumn}
            active={false}
          >
            <span className={tw`w-full flex items-center justify-between`}>
              <Icon name="Trash" />
              <span>Delete Column</span>
            </span>
          </MemoButton>
        </Toolbar.Wrapper>
      </BaseBubbleMenu>
    );
  }
);

TableColumnMenu.displayName = "TableColumnMenu";

export default TableColumnMenu;
